<template>
    <div></div>
</template>

<script>
    export default {
        name: "CatalogUtils",
        components: {},
        data: function () {
            return {}
        },
        computed:{},
        methods: {
          setMeta: function (object){
            document.title = (object.meta_title !== undefined ? object.meta_title : object.title + ' | PizzaProsto');
          },
          addAnchor: function (entity){
            const component = this;
            const entityCode = "#" + entity.entity_code;
            if(component.$route.hash !== entityCode) {
              this.$router.push({
                path: entityCode,
              });
            }
            return entityCode;
          },
          entityInUrlPath: function (catalogElement){
            const component = this;
            const url = component.$route.hash;
            if(url !== null && url.length > 0) {
              const urlProductCode = url.replace("#", "");
              return (urlProductCode !== undefined && urlProductCode.length > 0
                  && catalogElement.element['entity_code'] === urlProductCode);
            }
            return false;
          }
        },
        mounted() {},
        mixins: []
    }
</script>

<style scoped>

</style>
